import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  CompletedPollAnswer,
  CompletedTriviaAnswer,
  GamesGroupService,
  GroupType,
  IAnswer,
  ProcessedPredictorAnswer,
} from '@fgb/core';
import { firstValueFrom, tap } from 'rxjs';

@Component({
  selector: 'fgbcl-answer-type-text',
  templateUrl: './answer-type-text.component.html',
  styleUrl: './answer-type-text.component.scss',
})
export class AnswerTypeTextComponent implements OnInit {
  selectedAnswer: any;
  correctAnswerId: number;
  selectedAnswerIsCorrect: boolean;
  loading: boolean = false;
  groupTypes = GroupType;
  completed: boolean = false;
  @Input() answers: IAnswer[] | undefined;
  @Input() questionId: number;
  @Input() groupId: number;
  @Input() groupType: GroupType;
  @Input() isExternal: boolean = false;
  @Output() answerSelected = new EventEmitter<any>();
  @Output() loadingState = new EventEmitter<boolean>();

  constructor(private gamesGroupService: GamesGroupService) {}

  ngOnInit(): void {
    if (this.groupType == GroupType.Predictor) {
      this.selectedAnswer = this.answers
        ?.map((answer) => answer as ProcessedPredictorAnswer | CompletedTriviaAnswer | CompletedPollAnswer)
        .find((answer) => answer.UserSelected);
    }
  }

  onAnswerSelected(answer: any) {
    if (this.groupType == GroupType.Trivia) {
      this.submitTriviaAnswer(answer);
    } else {
      this.selectedAnswer = answer;
      this.answerSelected.emit(answer);
    }
  }

  /**
   * submit trivia answer and fetch updated trivia games model with answered questions and points
   * @param answer selected trivia answer
   */
  submitTriviaAnswer(answer: any) {
    if (this.completed) {
      return;
    }
    this.selectedAnswer = answer;
    this.loading = true;
    this.loadingState.emit(this.loading);
    firstValueFrom(
      this.gamesGroupService.submitTriviaAnswer(this.questionId, this.selectedAnswer.Id, this.groupId, this.isExternal).pipe(
        tap((result) => {
          this.correctAnswerId = result.CorrectAnswerId;
          this.selectedAnswerIsCorrect = this.correctAnswerId == this.selectedAnswer.Id;
        })
      )
    ).then(() => {
      firstValueFrom(this.gamesGroupService.fetchTriviaGroupGames(this.groupId, this.isExternal)).then((gameDetails) => {
        setTimeout(() => {
          this.answers = gameDetails.Questions.find((question) => question.Id == this.questionId)?.Answers;
          this.loading = false;
          this.completed = true;
          this.loadingState.emit(this.loading);
          this.answerSelected.emit(gameDetails);
        }, 300);
      });
    });
  }
}
